import { ReactNode } from 'react';
import './auth.css';

interface IAuthCard {
    titulo: string;
    subtitulo?: ReactNode;
    children: ReactNode;
}

/**
 * Moldura das telas de fora do login (entrar, cadastro, recuperar senha): painel roxo da
 * marca à esquerda e o formulário à direita. No celular o painel vira uma faixa no topo.
 */
export default function AuthCard({ titulo, subtitulo, children }: IAuthCard) {
    return (
        <div className='auth-pagina'>
            <aside className='auth-vitrine'>
                <div className='auth-vitrine-marca'>
                    <span className='auth-vitrine-simbolo' aria-hidden='true'>R</span>
                    <span className='auth-vitrine-nome'>Rico</span>
                </div>
                <div className='auth-vitrine-texto'>
                    <p className='auth-vitrine-chamada'>Compras, estoque e relatórios.</p>
                    <span className='auth-vitrine-fio' aria-hidden='true' />
                </div>
                <span className='auth-vitrine-rodape'>rico.net.br</span>
            </aside>
            <main className='auth-area'>
                <div className='auth-cartao'>
                    <h1 className='auth-titulo'>{titulo}</h1>
                    {subtitulo && <p className='auth-subtitulo'>{subtitulo}</p>}
                    {children}
                </div>
            </main>
        </div>
    );
}
